/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_S4Inputs */

const en_tut_rapat_s4 = /** @type {(inputs: Tut_Rapat_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`During the call: **Bagikan layar**, **Angkat tangan**, send reactions, and type in **Percakapan meeting**.`)
};

const id_tut_rapat_s4 = /** @type {(inputs: Tut_Rapat_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selama rapat: **Bagikan layar**, **Angkat tangan**, kirim reaksi, dan tulis di **Percakapan meeting**.`)
};

/**
* | output |
* | --- |
* | "During the call: **Bagikan layar**, **Angkat tangan**, send reactions, and type in **Percakapan meeting**." |
*
* @param {Tut_Rapat_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_s4 = /** @type {((inputs?: Tut_Rapat_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_s4(inputs)
	return en_tut_rapat_s4(inputs)
});